import { createContext } from "react"

const TemplatesContext = createContext({})

export default TemplatesContext
